import type { StatusSyncCrmToAircallEventPublisher } from '@usecases/status-sync-crm-to-aircall.usecase';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import { Logger } from '@main/utils/logger';

export class StatusSyncCrmToAircallPublisher
  implements StatusSyncCrmToAircallEventPublisher
{
  private logger: Logger;
  constructor() {
    this.logger = new Logger();
  }

  async publishStatus(status: string): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    const busEvent: BusEvent = {
      type: 'API.UPDATE_AVAILABILITY',
      payload: {
        state: status,
      },
    };

    this.logger.info('Publisher: Sync user status from CRM to Aircall', {
      action: 'StatusSyncCrmToAircall',
      status,
    });

    await BusEventsPromisifier.promisifySyncEvent({
      target: busIframe,
      event: busEvent,
      fulfilled: 'API.UPDATE_AVAILABILITY_FULFILLED',
      rejected: 'API.UPDATE_AVAILABILITY_REJECTED',
    });
  }
}
